
import _ from 'lodash';
import ConvokeObjectManager from './ConvokeObjectManager'
import { ItemServiceFactory } from '../../services/ItemServiceFactory';

class ConvokeEntityObjectManager extends ConvokeObjectManager {
    constructor( id, coreContext, coreState,operationName, isWarning) {
        super( id, coreContext, coreState, (new ItemServiceFactory()).ItemServiceEnum.EntityObject,(new ItemServiceFactory()).ItemServiceEnum.EntityQuery, operationName, isWarning);
    }
}

export default ConvokeEntityObjectManager;